// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__x-wka"};